import React from 'react';
import SEOHead from './components/SEOHead';
import { SITE_URL } from './utils/seo';
import MainHeader from './header/MainHeader';
import Footer from './footer/Footer';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ContactUs() {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead
        title="Na Kontakto - AutoPlace | Asistencë 24/7"
        description="Na kontakto për çdo pyetje rreth blerjes ose shitjes së makinave në AutoPlace Shqipëri. Ekipi ynë është i disponueshëm 24/7 për t'ju ndihmuar."
        canonical={`${SITE_URL}/contact-us`}
      />
      <MainHeader />

      {/* ===== Hero Section ===== */}
      <div className="mysearch-section">
        <div className="mysearch-content">
          <h1>{t('contact.title')}</h1>
        </div>
      </div>
      <section className="contact-page">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-8">
              <div className="appoinment-one__form">
                <div className="title-box">
                  <h2>{t('contact.form_title')}</h2>
                </div>
                <form>
                  <div className="row g-3">
                    <div className="col-md-6 w-100">
                      <input
                        type="text"
                        className="form-control custom-input"
                        id="name"
                        placeholder={t('contact.name_placeholder')}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="email"
                        className="form-control custom-input"
                        id="email"
                        placeholder={t('contact.email_placeholder')}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="input-group">
                        <span className="input-group-text">+355</span>
                        <input
                          type="tel"
                          className="form-control custom-input"
                          id="phone"
                          placeholder={t('contact.phone_placeholder')}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <textarea
                        className="form-control custom-input"
                        id="message"
                        rows={5}
                        placeholder={t('contact.message_placeholder')}
                        required
                      ></textarea>
                    </div>
                    <div className="col-12 text-center">
                      <button
                        type="submit"
                        className="btn btn-submit mt-3 w-100"
                      >
                        {t('contact.submit')}
                      </button>
                    </div>
                  </div>
                </form>
                <div>
                  <p className="mt-4">
                    {t('contact.disclaimer')}{' '}
                    <Link to="/privacy-policy">{t('contact.privacy_policy')}</Link>.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="contact-page__contact-info">
                <div className="title-box">
                  <h3>{t('contact.service_title')}</h3>
                  <p>{t('contact.service_subtitle')}</p>
                </div>
                <div className="contact-page__contact-info-box">
                  <div className="contact-page__contact-info-single">
                    <div className="icon-box">
                      <span className="icon-telephone-call">
                        <i className="fa-solid fa-gear"></i>
                      </span>
                    </div>
                    <div className="content-box">
                      <h5>{t('contact.hours_title')}</h5>
                      <p className="mb-1">
                        {t('contact.hours_private')} <br />
                        <a href="tel:+447418602800">+44 741 860 2800</a>
                      </p>
                      <small>{t('contact.hours_note')}</small>
                    </div>
                  </div>

                  <div className="contact-page__contact-info-single">
                    <div className="icon-box">
                      <span className="icon-email-1">
                        <i className="fas fa-phone"></i>
                      </span>
                    </div>
                    <div className="content-box">
                      <h5>{t('contact.dealers_title')}</h5>
                      <p className="mb-1">
                        <a href="tel:+447418602800">+44 741 860 2800</a>
                      </p>
                      <small>{t('contact.hours_note')}</small>
                    </div>
                  </div>

                  <div className="contact-page__contact-info-single">
                    <div className="content-box">
                      <h5>{t('contact.fraud_title')}</h5>
                      <p>{t('contact.fraud_desc')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ContactUs;
